import Vue from 'vue';
import {request, setAuthInHeader} from "@/api/request";
// import {req} from "vuelidate/src/validators/common";


Vue.prototype.$api = {
    $auth: { // 계정 로그인 / 회원가입 api
        login(params) {
            return request.post('member/login', params).then(({data}) => data);
        },
    },
    $member: {
        getMember(params) {
            return request.get(`member/admin`, params).then(({data}) => data);
        },
        getMemberDetail(params) {
            return request.get(`member/info`, params).then(({data}) => data);
        },
        updateMember(params) {
            return request.post(`member/update`, params).then(({data}) => data);
        },
        updateMemberPortfolio(params) {
            return request.post(`member/profile/update`, params).then(({data}) => data);
        },
        createMember(params) {
            return request.post('member', params).then(({data}) => data);
        },
        // 나오면 수정
        getQuitMember(params) {
            return request.get(`member/out`, params).then(({data}) => data);
        },
        checkIdDuplicate(params) {
            return request.get('member/chk/id', params).then(({data}) => data);
        },
        checkNickDuplicate(params) {
            return request.get('member/chk/nick', params).then(({data}) => data);
        },
        getCurator(params) {
            return request.get(`curator`, params).then(({data}) => data);
        },
        approveCurator(params) {
            return request.post(`curator/approve`, params).then(({data}) => data);
        },
        refuseCurator(params) {
            return request.post(`curator/deny`, params).then(({data}) => data);
        },
        upgradeCurator(params) {
            return request.post(`curator/upgrade`, params).then(({data}) => data);
        },
        downgradeCurator(params) {
            return request.post(`curator/downgrade`, params).then(({data}) => data);
        },
        // getProfile(params) {
        //     return request.get('member/profile', params).then(({data}) => data);
        // },
    },
    $board: {
        getNotice(params) {
            return request.get("board/notice", params).then(({data}) => data);
        },
        createNotice(params) {
            return request.post("board/notice", params).then(({data}) => data);
        },
        updateNotice(params) {
            return request.post("board/notice/update", params).then(({data}) => data);
        },
        deleteNotice(params) {
            return request.post("board/notice/delete", params).then(({data}) => data);
        },
        getFaq(params) {
            return request.get("board/faq", params).then(({data}) => data);
        },
        createFaq(params) {
            return request.post("board/faq", params).then(({data}) => data);
        },
        updateFaq(params) {
            return request.post("board/faq/update", params).then(({data}) => data);
        },
        deleteFaq(params) {
            return request.post("board/faq/delete", params).then(({data}) => data);
        },
        getQna(params) {
            return request.get("board/qna", params).then(({data}) => data);
        },
        updateQnaComment(params) {
            return request.post("board/qna", params).then(({data}) => data);
        },
        updateQna(params) {
            return request.post("board/qna/update", params).then(({data}) => data);
        },
        deleteQna(params) {
            return request.post("board/qna/delete", params).then(({data}) => data);
        },
        getCategory(params) {
            return request.get(`board/faq/category`, params).then(({data}) => data);
        },
        createCategory(params) {
            return request.post(`board/faq/category`, params).then(({data}) => data);
        },
        // getLanguage(params) {
        //     return request.get(`/country`, params).then(({data}) => data);
        // },
        updateCategory(params) {
            return request.post(`board/faq/category/update`, params).then(({data}) => data);
        },
        deleteCategory(params) {
            return request.post(`board/faq/category/delete`, params).then(({data}) => data);
        },
    },
    $point: {
        getPoint(params) {
            return request.get(`point`, params).then(({data}) => data);
        },
        updatePoint(params) {
            return request.post(`point`, params).then(({data}) => data);
        },
        getPointWithdraw(params) {
            return request.get(`point/withdraw`, params).then(({data}) => data);
        },
        getProduct(params) {
            return request.get(`itempoint`, params).then(({data}) => data);
        },
        createProduct(params) {
            return request.post(`itempoint`, params).then(({data}) => data);
        },
        updateProduct(params) {
            return request.post(`itempoint/update`, params).then(({data}) => data);
        },
        deleteProduct(params) {
            return request.post(`itempoint/delete`, params).then(({data}) => data);
        },
        cancelCharge(params) {
            return request.post(`point/order/cancel`, params).then(({data}) => data);
        },
        getService(params) {
            return request.get(`point/define`, params).then(({data}) => data);
        },
        updateService(params) {
            return request.post(`point/define/update`, params).then(({data}) => data);
        },
        approveWithdraw(params) {
            return request.post(`point/withdraw/status/approve`, params).then(({data}) => data);
        },
        denyWithdraw(params) {
            return request.post(`point/withdraw/status/deny`, params).then(({data}) => data);
        },
        getDeposit(params) {
            return request.get(`deposit`, params).then(({data}) => data);
        },
        acceptDeposit(params) {
            return request.post('deposit/accept', params).then(({data}) => data);
        },
        cancelDeposit(params) {
            return request.post('deposit/cancel', params).then(({data}) => data);
        },
        getOrder(params) {
            return request.get(`order`, params).then(({data}) => data);
        },
    },
    $curation: {
        getCuration(params) {
            return request.get(`item/curation/auction`, params).then(({data}) => data);
        },
    },
    $item: {
        getItem(params) {
            return request.get(`item/admin`, params).then(({data}) => data);
        },
        getItemDetail(params) {
            return request.get(`item/admin/find`, params).then(({data}) => data);
        },
        getDetection(params) {
            return request.get(`lawsuit/admin`, params).then(({data}) => data);
        },
        getRequestDetail(params) {
            let l_idx = params.l_idx;
            if (params.hasOwnProperty('l_idx')) {
                delete params.l_idx;
            }
            return request.get(`lawsuit/detail/${l_idx}`, params).then(({data}) => data);
        },
        updateDetectionStatus(params) {
            return request.post(`lawsuit/update/status`, params).then(({data}) => data);
        },
        updateDetectionPrice(params) {
            return request.post(`lawsuit/update/price`, params).then(({data}) => data);
        },
        createItem(params) {
            return request.post(`item`, params).then(({data}) => data);
        },
        addHash(params) {
            return request.post(`item/nft/add`, params).then(({data}) => data);
        },
        getItemCategory(params) {
            return request.get(`itemcategory`, params).then(({data}) => data);
        },
        updateItem(params) {
            return request.post(`item/update`, params).then(({data}) => data);
        },
        deleteItem(params) {
            return request.post(`item/delete`, params).then(({data}) => data);
        },
        assumeItem(params) {
            return request.post(`market/assume`, params).then(({data}) => data);
        },
        cancelItem(params) {
            return request.post(`market/assume/cancel`, params).then(({data}) => data);
        },

        getCollect(params) {
            return request.get(`collect`, params).then(({data}) => data);
        },
        updateCollect(params) {
            return request.post(`collect/update`, params).then(({data}) => data);
        },
    },
    $competition: {
        getCompetition(params) {
            return request.get(`contest`, params).then(({data}) => data);
        },
        getCompetitionDetail(params) {
            return request.get(`contest/detail`, params).then(({data}) => data);
        },
        updateCompetition(params) {
            return request.post(`contest/update`, params).then(({data}) => data);
        },
        deleteCompetition(params) {
            return request.post(`contest/delete`, params).then(({data}) => data);
        },
        getCompetitionItem(params) {
            return request.get(`contest/item`, params).then(({data}) => data);
        },
        getEntryDetail(params) {
            return request.get(`contest/item/judge`, params).then(({data}) => data);
        },
        getAward(params) {
            return request.get(`contest/item/prize`, params).then(({data}) => data);
        },

    },
    $collection: {
        getCollection(params) {
            return request.get(`collection`, params).then(({data}) => data);
        },
        deleteCollection(params) {
            return request.post(`collection/delete`, params).then(({data}) => data);
        },
        updateCollection(params) {
            return request.post(`collection/update`, params).then(({data}) => data);
        },

    },
    $banner: {
        getBanner(params) {
            return request.get(`banner`, params).then(({data}) => data);
        },
        createBanner(params) {
            return request.post(`banner`, params).then(({data}) => data);
        },
        updateBanner(params) {
            return request.post(`banner/update`, params).then(({data}) => data);
        },
        deleteBanner(params) {
            return request.post(`banner/delete`, params).then(({data}) => data);
        },
    },
    $file: {
        getFile(params) {
            return request.get("file", params).then(({data}) => data);
        },
        editorUpload(params) {
            return request.post("file/editorUpload", params).then(({data}) => data);
        },
        downLoad(params) {
            return request.get(params).then(({data}) => data);
        },
        updateFile(params) {
            return request.post(`file`, params).then(({data}) => data);
        },
        deleteFile(params) {
            return request.post("file/delete/" + params.a_idx).then(({data}) => data);
        }
    },
    $config: {
        getGroup(params) {
            return request.get(`group`, params).then(({data}) => data);
        },
        getTerms(params) {
            return request.get(`config`, params).then(({data}) => data);
        },
        updateTerms(params) {
            return request.post(`config/update`, params).then(({data}) => data);
        },
        createTerms(params) {
            return request.post(`config`, params).then(({data}) => data);
        },
        deleteTerms(params) {
            return request.post(`config/delete`, params).then(({data}) => data);
        }
    },
    $handler: {
        authHeader: setAuthInHeader
    },
    $utility: {
        getUtility(params){
            return request.get(`utility`,params).then(({data}) => data);
        },
        getUtilityCategory(params){
            return request.get(`utility/category`, params).then(({data})=>data);
        },
        getUtilityTransaction(params) {
            return request.get(`utility/deal`, params).then(({data}) => data);
        },
        deleteUtility(params) {
            return request.post(`utility/delete`, params).then(({data}) => data);
        },
        getUtilityManager(params) {
            return request.get(`utility/manager`, params).then(({data}) => data);
        },
    },
};

export default Vue.prototype.$api;
